import React from 'react';
import copy from 'copy-to-clipboard';
import { Button, useToast, Icon } from '@pairy/pds-react';

import useUpdateClientShare from '@/hooks/mutations/client/useUpdateClientShare';
import useShareUrl from '@/hooks/useShareUrl';

interface Props {
  className?: string;
  hashId: string;
  clientId: number;
  type: 'file' | 'link';
  id: number;
  content?: string;
  variant?: 'inlineBorderLess' | 'basic';
}

const LinkCopyButton = ({
  className,
  hashId,
  clientId,
  id,
  type,
  content = '고객에게 보낼 링크',
  variant = 'inlineBorderLess',
}: Props) => {
  const { mutate } = useUpdateClientShare();
  const toast = useToast();

  const { url } = useShareUrl({
    targetType: type === 'file' ? 'CLIENT_FILE' : 'CLIENT_LINK',
    identifier: hashId,
  });

  const handleClickLinkCopyButton = (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.stopPropagation();

    mutate({
      type,
      id,
      clientId,
    });

    copy(url);

    toast('링크가 복사되었습니다.');
  };

  return (
    <>
      {variant === 'inlineBorderLess' && (
        <Button
          className={className}
          variant="skyblue_100"
          textVariant="sm-medium"
          radius={4}
          paddingX={8}
          paddingY={4}
          borderLess
          InnerWrappeGap={4}
          leftIcon={<Icon icon="ph:link" size={17} color="skyblue_400" />}
          onClick={handleClickLinkCopyButton}
        >
          {content}
        </Button>
      )}
      {variant === 'basic' && (
        <Button
          className={className}
          width="100%"
          variant="skyblue_400"
          textVariant="md-medium"
          radius={99}
          paddingY={8}
          InnerWrappeGap={4}
          leftIcon={<Icon icon="ph:link" size={17} />}
          onClick={handleClickLinkCopyButton}
        >
          {content}
        </Button>
      )}
    </>
  );
};

export default LinkCopyButton;
